module.exports = __webpack_public_path__ + "img/guards4.ebcf0008.jpg";